<template>
	<div class="page">
		<div class="topView">
			<div class="topViewL">
				<div></div>
				<div>广告位</div>
			</div>
			<div class="topViewR">
				<el-button type="warning" plain @click="handleBackClick">返回</el-button>
			</div>
		</div>
		<div class="comViewWrap">
			<div class="comView">
				<div class="comViewL">广告名称：</div>
				<div class="comViewR">
					<el-input v-model="title" placeholder="请输入广告名称" style="width: 368px;"></el-input>
				</div>
			</div>
			<div class="comView" v-if="showLLocationList==true">
				<div class="comViewL">广告位置：</div>
				<div class="comViewR">
					<el-select v-model="location" placeholder="请选择广告位置" style="width: 368px;">
						<el-option v-for="item in adList" :key="item.item_id" :label="item.item_name"
							:value="item.item_id" />
					</el-select>
				</div>
			</div>
			<div class="comView">
				<div class="comViewL">广告周期：</div>
				<div class="comViewR">
					<el-date-picker v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期"
						end-placeholder="结束日期" style="margin-right:16px;width: 368px;">
					</el-date-picker>
				</div>
			</div>
			<div class="comView">
				<div class="comViewL">广告图片：</div>
				<div class="comViewR">
					<el-upload class="avatar-uploader" action="https://res.huashengchongwu.com/api/media/upload_img"
						:show-file-list="false" :http-request="uploadCoverImg">
						<img v-if="pic_url" :src="pic_url" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</div>
			</div>
		</div>
		<div class="comViewWrap" style="margin-top: 16px;">
			<div class="comView">
				<div class="comViewL">广告跳转：</div>
				<div class="comViewR" style="display: flex;align-items: center;">
					<div class="drawerSelect">
						<div :class="skip_type == 1?'drawerSelectActiveItem':'drawerSelectItem'" @click="skip_type = 1">
							<div></div>
							<div>外部跳转</div>
						</div>
						<div :class="skip_type == 2?'drawerSelectActiveItem':'drawerSelectItem'" @click="skip_type = 2">
							<div></div>
							<div>内部跳转</div>
						</div>
						<div :class="skip_type == 0?'drawerSelectActiveItem':'drawerSelectItem'" @click="skip_type = 0">
							<div></div>
							<div>无</div>
						</div>
					</div>
					<!-- 内部地址 -->
					<el-select v-model="skipInfo" placeholder="请选择内部地址" style="margin-right: 16px;"
						v-if="skip_type == 2" @change="handleOpenDrawer">
						<el-option v-for="item in locationList" :key="item.item_id" :label="item.item_name"
							:value="item.item_code" />
					</el-select>
					<div
						v-if="skip_type == 2 && skipInfo != null && (skipInfo == 'wenzhangxiangqing' || skipInfo == 'productdetails' || skipInfo == 'huotixiangqing' || skipInfo == 'chongbaike')">
						{{param_name}}
					</div>
					<!-- 外部地址 -->
					<el-input v-model="url_param" placeholder="请输入外部地址" v-if="skip_type == 1" style="width: 200px;">
					</el-input>
				</div>
			</div>
		</div>
		<div class="btnView">
			<div @click="handleSubmitClick">提交</div>
		</div>

		<!-- 内部地址弹框 -->
		<div v-if="drawerInteral_state">
			<drawerInteral @closeOn="handleDetailClose" :comState="drawerInteral_state" :navType="navType">
			</drawerInteral>
		</div>
	</div>
</template>

<script>
	import drawerInteral from './drawerInteral.vue'
	export default {
		components: {
			drawerInteral
		},
		data() {
			return {
				locationList: [], //位置列表
				pic_url: '',
				title: '',
				location: '',
				skip_type: 0, //0无跳转 1外部 2内部
				date: '',
				remark: '', //备注
				url_param: '', //外部地址
				navType: 0, //跳转
				drawerInteral_state: false,
				skipInfo: '',
				param_id: '',
				param_name: '',
				listType: this.$route.query.type,
				listId: this.$route.query.id,
				defaultLocation: this.$route.query.location,
				showLLocationList: true,
				adList: [],
			}
		},
		mounted() {


			this.getAdData()
			this.getLocationData()
			if (this.listType == 2) {
				this.getDetailData()
			}

		},

		methods: {
			//返回
			handleBackClick() {
				this.$router.back();
			},
			//获取详情
			getDetailData() {
				let params = {
					id: this.listId
				}
				this.$http.get(process.env.VUE_APP_AppAdmin + '/api/Banner/GetBannerRecord', params).then((res) => {
					if (res.code == 0) {
						this.title = res.data.title;
						this.pic_url = res.data.pic_url;
						this.remark = res.data.remark;
						this.location = res.data.location_info.id;
						this.date = [new Date(res.data.begin_time * 1000), new Date(res.data.end_time * 1000)];
						this.skip_type = res.data.skip_type;
						if (this.skip_type == 1) {
							this.url_param = res.data.url_param
						} else if (this.skip_type == 2) {
							this.skipInfo = res.data.skip_param.jump_type.code;
							this.param_id = res.data.skip_param.param_id;
							this.param_name = res.data.skip_param.param_name;
						}

					}
				})
			},
			//关闭弹框
			handleDetailClose(val) {
				this.drawerInteral_state = false;
				if (val.type == "submit") {
					this.param_id = val.data.param_id;
					this.param_name = val.data.param_name;
				}
			},
			//打开弹框
			handleOpenDrawer() {
				if (this.skipInfo == 'wenzhangxiangqing') {
					this.navType = 1;
					this.drawerInteral_state = true;
				} else if (this.skipInfo == 'productdetails') {
					this.navType = 2;
					this.drawerInteral_state = true;
				} else if (this.skipInfo == 'huotixiangqing') {
					this.navType = 3;
					this.drawerInteral_state = true;
				} else if (this.skipInfo == 'chongbaike') {
					this.navType = 4;
					this.drawerInteral_state = true;
				}

			},
			//提交
			handleSubmitClick() {
				if (this.title == '') {
					this.$message({
						type: 'error',
						message: '请输入广告名称'
					});
					return
				}
				if (this.location == '') {
					this.$message({
						type: 'error',
						message: '请选择广告位置'
					});
					return
				}
				if (this.date == '') {
					this.$message({
						type: 'error',
						message: '请选择广告周期'
					});
					return
				}
				if (this.pic_url == '') {
					this.$message({
						type: 'error',
						message: '请选择广告图片'
					});
					return
				}
				let params = {
					title: this.title,
					remark: this.remark,
					pic_url: this.pic_url,
					system_info: {
						name: 'app',
						code: 'app'
					},

					skip_type: this.skip_type
				}

				this.adList.map(item => {
					if (item.item_id == this.location) {
						params.location_info = {
							id: item.item_id,
							name: item.item_name,
							code: item.item_code
						}
					}
				})
				if (this.date != '') {
					params.begin_time = new Date(this.date[0]).getTime() / 1000;
					params.end_time = new Date(this.date[1]).getTime() / 1000;
				} else {
					params.begin_time = 0;
					params.end_time = 0;
				}
				if (this.skip_type == 0) {
					params.skip_param = null;
					params.url_param = '';
				} else if (this.skip_type == 1) { //外部链接
					params.skip_param = null;
					params.url_param = this.url_param;
				} else if (this.skip_type == 2) { //内部链接
					params.url_param = '';
					params.skip_param = {

					}
					this.locationList.map(item => {
						if (item.item_code == this.skipInfo) {
							params.skip_param = {
								jump_type: {
									id: item.item_id,
									name: item.item_name,
									code: item.item_code
								},
								param_id: this.param_id,
								param_name: this.param_name
							}
						}
					})
				}

				if (this.listType == 1) {
					this.$http.post(process.env.VUE_APP_AppAdmin + '/api/Banner/CreateBannerRecord', params).then((
						res) => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '已新增'
							});
						
                            this.$router.back();
						}
                       
					})
				} else {
					params.id = this.listId;
					this.$http.post(process.env.VUE_APP_AppAdmin + '/api/Banner/UpdateBannerRecord', params).then((
						res) => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '已变更'
							});
                            this.$router.back();
						}
                       
					})
				}

			},
			getAdData() {
				let params = {
					code: 'Advertising space'
				}
				this.$http.get(process.env.VUE_APP_zichan + '/api/SystemConfig/GetSystemDictionByCode', params).then((
					res) => {
					if (res.code == 0) {
						this.adList = res.data.item_list
					}
				})
			},
			//获取位置列表
			getLocationData() {
				let params = {
					code: 'guanggaoweitiaozhuanleixing'
				}
				this.$http.get(process.env.VUE_APP_zichan + '/api/SystemConfig/GetSystemDictionByCode', params).then((
					res) => {
					if (res.code == 0) {
						this.locationList = res.data.item_list
                        console.log("this.locationList",this.locationList);
						if (this.defaultLocation) {
							this.location = this.defaultLocation
							this.showLLocationList = false
						}


					}
				})
			},
			uploadCoverImg(item) {
				var formData = new FormData();
				formData.append('img', item.file);
				this.$upload.uploadImg_dir(formData, {
					dir: 'appImg'
				}).then(data => {
					if (data.timestamp) {
						this.pic_url = data.url;
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.page {
		.topView {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin: 16px;

			.topViewL {
				display: flex;
				align-items: center;
				font-size: 18px;
				color: #343440;
				font-weight: bold;

				div:nth-of-type(1) {
					width: 5px;
					height: 20px;
					background: linear-gradient(315deg, #338AFF 0%, #3F69FF 100%);
					border-radius: 4px;
					margin-right: 12px;
				}
			}
		}

		.btnView {
			display: flex;
			justify-content: center;
			margin-top: 32px;

			div:nth-of-type(1) {
				width: 128px;
				height: 44px;
				background: linear-gradient(135deg, #5685FF 0%, #3569FF 100%);
				border-radius: 8px;
				color: #fff;
				text-align: center;
				line-height: 44px;
				font-size: 14px;
			}
		}

		.comViewWrap {
			padding: 34px 0;
			background: #fff;
			border-radius: 16px;
			margin: 0 16px;
		}

		.comView {
			display: flex;
			margin-top: 32px;

			.comViewL {
				width: 132px;
				margin-right: 22px;
				font-size: 14px;
				color: #343440;
				text-align: right;
				line-height: 20px;
				margin-top: 12px;
			}

			.comViewR {
				flex: 1;

				.avatar-uploader .el-upload {
					cursor: pointer;
					position: relative;
					overflow: hidden;
				}

				.avatar-uploader .el-upload:hover {
					border-color: #409EFF;
				}

				.avatar-uploader-icon {
					font-size: 28px;
					color: #8c939d;
					width: 128px;
					height: 128px;
					line-height: 128px;
					text-align: center;
					background: #F0F0F7;
					border: 1px dashed #B0B0BF;
					border-radius: 8px;
					box-sizing: border-box;
				}

				.avatar {
					width: 128px;
					height: 128px;
					display: block;
					object-fit: cover;
				}

				.drawerSelect {
					display: flex;

					.drawerSelectItem {
						width: 128px;
						height: 44px;
						box-sizing: border-box;
						font-size: 14px;
						color: #69697B;
						text-align: center;
						line-height: 44px;
						position: relative;
						background: #FAFAFD;
						border-radius: 8px;
						margin-right: 16px;

						div:nth-of-type(1) {
							position: absolute;
							left: 16px;
							top: 0;
							bottom: 0;
							margin: auto 0;
							width: 16px;
							height: 16px;
							border-radius: 100%;
							border: solid 1px #B0B0BF;
						}
					}

					.drawerSelectActiveItem {
						width: 128px;
						height: 44px;
						box-sizing: border-box;
						font-size: 14px;
						color: #577BFF;
						text-align: center;
						line-height: 44px;
						position: relative;
						background: #FAFAFD;
						border-radius: 8px;
						margin-right: 16px;
						border: 1px solid #577BFF;

						div:nth-of-type(1) {
							position: absolute;
							left: 16px;
							top: 0;
							bottom: 0;
							margin: auto 0;
							width: 4px;
							height: 4px;
							border-radius: 100%;
							border: solid 6px #577BFF;
						}
					}
				}
			}
		}

		.comView:nth-of-type(1) {
			margin-top: 0;
		}
	}
</style>
